<script setup>
  import { onMounted } from "vue";
  const props = defineProps({ blok: Object });

  import TwoStoriesLayoutOne from "@/components/TwoStoriesLayoutOne.vue";
  import TwoStoriesLayoutTwo from "@/components/TwoStoriesLayoutTwo.vue";

  onMounted(() => {
    console.log("Story Blok:", props.blok);
  });
</script>

<template>
  <div class="transform-container two-stories blok3">
    <!-- Two columns -->

    <div>
      <two-stories-layout-one
        v-if="blok.layout === '1'"
        :blok="blok"
      />
    </div>
    <!-- Two columns variant -->
    <two-stories-layout-two
      v-if="blok.layout === '2'"
      :blok="blok"
    />
  </div>
</template>

<style lang="scss">
  .two-columns {
    border-top: 1px dotted #000;
    // border-bottom: 1px dotted #000;
    margin-bottom: -50px;

    .v-row,
    div[class*="v-col"] {
      padding: 0;
      margin: 0;
    }

    .story-overlay {
      position: relative;

      &--content {
        background-color: rgba(0, 0, 0, 0.4);
        position: absolute;
        width: 100%;
        height: 100%;
        z-index: 2;
        display: flex;
        justify-content: space-between;
        flex-direction: column;
      }

      &--title {
        font-size: 2.5rem;
        line-height: 3rem;
        @media only screen and (min-width: 1920px) {
          font-size: 50px;
          line-height: 58px;
        }
      }

      .article-meta {
        filter: invert(1);
      }
    }

    img {
      object-fit: cover;
    }

    .middle-border {
      width: 1px;
      border-top: 1px dotted var(--black-text-color);
      width: 100%;
      margin-top: 40px;
      margin-bottom: 64px;
      // @media (width <= 599px) {
      //   border-top: 1px dotted #000;
      //   width: 100%;
      //   margin-top: 40px;
      //   margin-bottom: 64px;
      // }
      @media (width >= 960px) {
        height: 100%;
        border-right: 1px dotted var(--black-text-color);
        border-top: none;
        margin-top: 0;
        margin-bottom: 0;
        position: relative;
        width: 0;
        left: 50%;
        transform: translateX(-50%);
      }
    }

    .heading-highlight {
      &.right-border {
        text-align: left;
        @media (width >= 960px) {
          border-left: 2px solid var(--black-text-color);
          padding-left: 20px;
          border-right: none;
          text-align: left;
          padding-right: 0;
          width: 70%;
        }
      }

      @media only screen and (min-width: 600px) {
        font-size: 1.875rem;
        line-height: 2.25rem;
      }
      @media only screen and (min-width: 960px) {
        font-size: 2.2rem;
        line-height: 2.5rem;
      }
      @media only screen and (min-width: 1920px) {
        font-size: 50px;
        line-height: 58px;
      }
    }
  }
</style>
